import { SaleAnalyticsOverview } from './SaleAnalyticsOverview'
import { withSaleAnalyticsOverview } from './withSaleAnalyticsOverview'

const ConnectedSaleAnalyticsOverview = withSaleAnalyticsOverview(
  SaleAnalyticsOverview
)

export { ConnectedSaleAnalyticsOverview as SaleAnalyticsOverview }
